import { Component } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  DialogBodyComponent,
  DialogHeaderComponent,
  DialogRef,
  NewItemButtonComponent,
} from '@core/user-interface-legacy';

import { CreateMode } from '../../requisitions.types';

type DialogResult = {
  mode: CreateMode;
};

@Component({
  selector: 'rt-requisitions-create-requisition-dialog',
  templateUrl: './create-requisition-dialog.component.html',
  styleUrls: ['./create-requisition-dialog.component.less'],
  imports: [DialogBodyComponent, NewItemButtonComponent, DialogHeaderComponent, TranslatePipe],
})
export class CreateRequisitionDialogComponent implements DialogComponentI<void, DialogResult> {
  constructor(private dialogRef: DialogRef) {}

  public createBlank() {
    this.dialogRef.close({ mode: CreateMode.Blank });
  }

  public createDuplicate() {
    this.dialogRef.close({ mode: CreateMode.Duplicate });
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: void, triggerUpdate: boolean): void {}
}
